/**
 * @file index.tsx
 *
 * @fileoverview Renders a product box depending on the type of product
 * being displayed.
 */
import React from 'react';
import {
  CtaProductParagraph,
  Paragraph,
  ProductParagraph,
} from '~/jobiqo/types/types';
import CTAProductBox from '~/jobiqo/components/Landingpage/Products/components/CTAProductBox';
import ProductReferenceBox from '~/jobiqo/components/Landingpage/Products/components/ProductReferenceBox';

interface ProductBoxWrapperProps {
  /**
   * The product paragraph being displayed.
   */
  product: Paragraph;
}
export default function ProductBoxWrapper({ product }: ProductBoxWrapperProps) {
  if (product.bundle === 'product') {
    return <ProductReferenceBox product={product as ProductParagraph} />;
  }

  if (product.bundle === 'cta_product') {
    return <CTAProductBox product={product as CtaProductParagraph} />;
  }

  return null;
}
